import React, { useState } from 'react';
import cn from 'classnames';
import CONFIG from '../../../config';
import About from '../../../components/About/About';
import Loans from '../../../components/Loans/Loans';
import Additionally from '../../../components/Additionally/Additionally';

const { LINKS } = CONFIG;

interface IMenu {
    isMobile?: boolean;
}

/*DROP-MENU*/
const Menu: React.FC<IMenu> = ({ isMobile = false }) => {
    const [openedIndex, setOpenedIndex] = useState<number>(0);

    const setOpenedClass = (index: number): string => cn({ 'open': openedIndex === index });

    const setOpenedHandler = (index: number) => setOpenedIndex(openedIndex === index ? 0 : index);

    return (
        <nav className={cn(isMobile ? 'menu' : 'header__menu')}>
            <ul>
                <li>
                    <span className={setOpenedClass(1)} onClick={() => setOpenedHandler(1)}>О компании</span>
                    <About className={setOpenedClass(1)} />
                </li>
                <li>
                    <span className={setOpenedClass(2)} onClick={() => setOpenedHandler(2)}>Займы</span>
                    <Loans className={setOpenedClass(2)} />
                </li>
                <li>
                    <span className={setOpenedClass(3)} onClick={() => setOpenedHandler(3)}>Новости</span>
                    <Additionally className={setOpenedClass(3)} />
                </li>
                <li>
                    <a href={LINKS.BAIBOL.CONTACTS} target="_blank" rel="noopener noreferrer nofollow">Контакты</a>
                </li>
            </ul>
        </nav>
    );
}

export default Menu;